import { render, staticRenderFns } from "./ProductSelect.vue?vue&type=template&id=4170702b"
import script from "./ProductSelect.vue?vue&type=script&lang=js"
export * from "./ProductSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4170702b')) {
      api.createRecord('4170702b', component.options)
    } else {
      api.reload('4170702b', component.options)
    }
    module.hot.accept("./ProductSelect.vue?vue&type=template&id=4170702b", function () {
      api.rerender('4170702b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/ProductSelect.vue"
export default component.exports